angular
	.module 'App.Repository'
	.factory 'IntegrationLogRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class IntegrationLogRepository extends BaseRepository
				@resource = '/integration_logs'
				@isRestricted = true

			return new IntegrationLogRepository()
		]
